module.exports = __webpack_public_path__ + "static/img/illustration2.29e3f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/illustration2.png
// module id = k5Xe
// module chunks = 1